import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PTSSchemaMarkup from './components/PTSSchemaMarkup';
import PTSHeroSection from './components/PTSHeroSection';
import PTSIntroSection from './components/PTSIntroSection';
import PTSCategorySection from './components/PTSCategorySection';
import PTSRankedListSection from './components/PTSRankedListSection';
import PTSTravelStyleSection from './components/PTSTravelStyleSection';
import PTSWhyGlenFallsSection from './components/PTSWhyGlenFallsSection';
import PTSHowToChooseSection from './components/PTSHowToChooseSection';
import PTSFAQSection from './components/PTSFAQSection';
import PTSRelatedGuidesSection from './components/PTSRelatedGuidesSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://glenfallscabin.com';

export default function PlacesToStayHighlandsNC() {
  return (
    <>
      <title>Places to Stay in Highlands, NC | Top Cabins, Hotels and Rentals (2026)</title>
      <meta
        name="description"
        content="Looking for the best places to stay in Highlands, NC? Explore top cabins, vacation rentals, and hotels including Glen Falls Luxury Cabin, Old Edwards Inn, and more. Updated 2026 guide."
      />
      <meta
        name="keywords"
        content="places to stay in Highlands NC, where to stay in Highlands NC, Highlands NC lodging, best cabins in Highlands NC, vacation rentals Highlands NC"
      />
      <meta property="og:title" content="Best Places to Stay in Highlands, NC (2026 Guide)" />
      <meta
        property="og:description"
        content="A curated guide to the best places to stay in Highlands, NC — top cabins, vacation rentals, and hotels. Real properties, honest recommendations."
      />
      <meta name="robots" content="index, follow" />
      <meta name="geo.region" content="US-NC" />
      <meta name="geo.placename" content="Highlands, North Carolina" />
      <meta name="geo.position" content="35.0499;-83.1985" />
      <meta name="last-modified" content="2026-04-11" />
      <link rel="canonical" href={`${siteUrl}/places-to-stay-highlands-nc`} />
      <PTSSchemaMarkup />

      <Navbar />
      <main>
        <PTSHeroSection />
        <PTSIntroSection />
        <PTSCategorySection />
        <PTSRankedListSection />
        <PTSTravelStyleSection />
        <PTSWhyGlenFallsSection />
        <PTSHowToChooseSection />
        <PTSFAQSection />
        <PTSRelatedGuidesSection />

        {/* Final CTA */}
        <section className="bg-[#2D4A3E] py-20 px-6 lg:px-14">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-5">/ Plan Your Stay</p>
            <h2 className="font-cormorant text-5xl md:text-6xl text-white font-light mb-5">
              Ready to Book Your<br /><em className="italic">Highlands Trip?</em>
            </h2>
            <p className="text-white/65 font-jost text-sm leading-relaxed mb-10 max-w-lg mx-auto">
              Glen Falls Luxury Cabin is our top recommendation among all places to stay in Highlands, NC. Check availability and book directly or through Airbnb. For more options, browse our full guide to{' '}
              <Link to="/vacation-rentals-highlands-nc" className="text-[#C9A96E] underline underline-offset-2 hover:text-[#B8954F] transition-colors">
                vacation rentals in Highlands, NC
              </Link>.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="https://glenfallscabin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#C9A96E] hover:bg-[#B8954F] text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-10 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                View Glen Falls Luxury Cabin
              </a>
              <Link
                to="/things-to-do"
                className="border border-white/40 text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-10 py-4 rounded-full hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
              >
                Things to Do in Highlands
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
